import { CloseOutlined, EditOutlined, CheckOutlined } from '@ant-design/icons';

import { useState } from 'react';

import { Button, Select, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

const DELIVERY_TYPE_OPTIONS = [
  { value: 'SINGLE_LOCATION', label: 'Single Location' },
  { value: 'MULTI_LOCATION', label: 'Multi Location' }
];

const EditableDeliveryType = ({ deliveryType, editable, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [selectedType, setSelectedType] = useState(deliveryType);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSave = () => {
    const save = async () => {
      setLoading(true);
      const res = await onSave(selectedType);
      setLoading(false);
      setEditing(false);
      if (res) navigate(0);
    };
    save();
  };

  const handleCancel = () => {
    setSelectedType(deliveryType);
    setLoading(false);
    setEditing(false);
  };

  const getDeliveryTypeLabel = (value) => {
    const option = DELIVERY_TYPE_OPTIONS.find((opt) => opt.value === value);
    return option ? option.label : value;
  };

  if (editing) {
    return (
      <Space direction="vertical">
        <Select
          onChange={(value) => setSelectedType(value)}
          options={DELIVERY_TYPE_OPTIONS}
          style={{ width: 200 }}
          value={selectedType}
        />
        <Space>
          <Button
            className="action-btn"
            disabled={!selectedType || selectedType === deliveryType}
            icon={<CheckOutlined />}
            loading={loading}
            onClick={handleSave}
            type="link">
            Save
          </Button>
          <Button className="color-454C53" icon={<CloseOutlined />} onClick={handleCancel} size="small" type="link">
            Cancel
          </Button>
        </Space>
      </Space>
    );
  }

  return (
    <Space direction="vertical">
      <Text>{getDeliveryTypeLabel(deliveryType)}</Text>
      {editable ? (
        <Button className="action-btn" icon={<EditOutlined />} onClick={() => setEditing(true)} type="link">
          Edit
        </Button>
      ) : null}
    </Space>
  );
};

export default EditableDeliveryType;
